import { render, staticRenderFns } from "./front-orderreturn-list.vue?vue&type=template&id=42572418&"
import script from "./front-orderreturn-list.vue?vue&type=script&lang=ts&"
export * from "./front-orderreturn-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports